export class LogUpload {
    private _className: string = "";

    constructor(className: string) {
        this._className = className;
    }

    info = (methodName: string, message: string): void => {
        if (window.uiLoggerSdk != null)
            window.uiLoggerSdk.LogInfo(this._className, methodName, message);
    }

    debug = (methodName: string, message: string): void => {
        if (window.uiLoggerSdk != null)
            window.uiLoggerSdk.LogDebug(this._className, methodName, message);
    }

    warn = (methodName: string, message: string): void => {
        if (window.uiLoggerSdk != null)
            window.uiLoggerSdk.LogWarn(this._className, methodName, message);
    }

    error = (methodName: string, message: string, error: Error | null | undefined | any): void => {
        if (window.uiLoggerSdk != null) {
            if (error == null)
                window.uiLoggerSdk.LogError(this._className, methodName, message);
            else window.uiLoggerSdk.LogErrorWithException(this._className, methodName, message, error);
        }
    }
}